import React from 'react'
import PropTypes from 'prop-types'
import { HEIGHT_FEET } from '../../../../constant/NUMERICAL_SELECT_OPTIONS'
import RegisteredFormField from '../../../common/RegisteredFormField'

const HeightSelectFeet = ({ path }) => {
  return <RegisteredFormField
    inputType='select'
    id='heightFt'
    path={`${path}.heightFt`}
    options={HEIGHT_FEET}
    label='Height (Ft)'
    placeholder=' '
  />
}

HeightSelectFeet.propTypes = {
  /** The redux object root path for this form field's parent */
  path: PropTypes.string.isRequired,
}

export default HeightSelectFeet